"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sameOriginPostMessage = void 0;
const sameOriginPostMessage = (origin, returnUrl) => {
    try {
        const isSameOriginParentIframe = window.parent !== window && window.parent.location.origin === window.location.origin;
        if (!isSameOriginParentIframe) {
            return false;
        }
        window.parent.postMessage({
            event: 'child-gpasfe',
            type: 'redirect-to',
            returnUrl,
            origin,
        }, window.location.origin);
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.sameOriginPostMessage = sameOriginPostMessage;
